import {Subject} from "rxjs/Subject";

export class Session {
  public static loggedIn: boolean;
  public static loggedInObserver: Subject<boolean> = new Subject();
  public static headerObserver: Subject<boolean> = new Subject();


}



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/services/session.service.ts